export enum QueueStatusType {
	ACTIVE = 'active',
	LOCKED = 'locked',
	EMPTY = 'empty',
	OUT_SHIFT = 'out_shift',
}
